
import { filter } from 'rxjs/operators';
import { Component, Renderer2 } from '@angular/core';
import { AuthenticationService } from './shared/auth/authentication.service';
import { LoaderService } from './shared/providers/loader.service';
import { ToastService } from './shared/providers/toast.service';
import { Router, Event, NavigationStart, NavigationEnd, NavigationError } from '@angular/router';
import { ValidationService } from './shared/providers/validation.service';
import { BrowserService } from './shared/browser-service.service';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {

  showLoader = false;
  constructor(private authService: AuthenticationService, private renderer: Renderer2, private title: Title, private browserService: BrowserService, private loaderService: LoaderService, private Validation: ValidationService, private router: Router, private Toast: ToastService) {
    router.events.subscribe((event: Event) => {
      if (!this.browserService.document) {
        return;
      }
      if (event instanceof NavigationStart) {
        // Hide loading indicator
        (window as any).closeSlider();
      }
      if (event instanceof NavigationEnd) {
        this.currentPage = event.url.split('/')[1];
        //$("body").removeClass("open-sidemenu");
        (window as any).closeSlider();
      }
      if (event instanceof NavigationError) {
        // Hide loading indicator
        // Present error to user
        console.log(event.error);
      }
    });
  }

  ngOnInit() {

    this.loaderService.status.subscribe((val: boolean) => {
      if (this.showLoader !== val) {
        this.showLoader = val;
      }
    });

    if (this.authService.user != null) {
      this.authService.loggedIn.next(true);
    }

    if (navigator != undefined && navigator.userAgent != undefined) {
      var user_agent = navigator.userAgent.toLowerCase();
      if (user_agent.indexOf('android') > -1) { // Is Android.
        $(document.body).addClass('android');
      }
    }
  }
  onRouteChange() {
    if (!this.browserService.document) {
      return;
    }

    this.title.setTitle("B+E Buy Net Lease Properties");
    window.scrollTo(0, 0);
    this.router.events.pipe(filter(event => event instanceof NavigationEnd)).subscribe(e => {
      let currentPage = this.currentPage;
      if (localStorage.getItem('currentFileRefreshTab') != undefined && localStorage.getItem('currentFileRefreshTab') != null) {
        localStorage.removeItem('currentFileRefreshTab');
      }
      if (this.currentPage.indexOf('viewproperty') > -1) {
        var _newdocs = document.getElementById('be-floating-box1');
        if (_newdocs != null && _newdocs != undefined && !(_newdocs.classList.contains('be-floating-box-details'))) {
          _newdocs.classList.add('be-floating-box-details');
        }
      }
      else {
        var _newdocs = document.getElementById('be-floating-box1');
        if (_newdocs != null && _newdocs != undefined && _newdocs.classList.contains('be-floating-box-details')) {
          _newdocs.classList.remove('be-floating-box-details');
        }
      }
      this.authService.isLoggedIn.subscribe(response => {
        if (response && this.currentPage === "propertylisting?request=buy") {
          let collapseHeader = sessionStorage.getItem('collapseHeader');

          if (collapseHeader != null && collapseHeader != undefined) {
            if (collapseHeader == '1') {
              if (document.body.classList.contains('menu-collapse')) {
                this.renderer.removeClass(document.body, 'menu-collapse');
              }
             $("body").addClass('open-sidemenu');
            }
            else if (collapseHeader == '2') {
              this.renderer.addClass(document.body, 'menu-collapse');
            }
          }
        }
      });
    });

    $('body').removeClass('error404');

    //(<any>window).Intercom('boot', {
    //    hide_default_launcher: true
    //});
    //this.router.events.subscribe(event => {
    //    if (event instanceof NavigationEnd) {
    //    this.router.events
    //        .filter(event => event instanceof NavigationEnd)
    //        .subscribe(e => {
    //            let prevRoute = event.url
    //            if (prevRoute !== undefined && prevRoute.indexOf('dashboard-1031') > -1) {
    //                this.Toast.clearAllToast();
    //            }
    //        });
    //    };
    //});

  }
  onMessageClick() {
    //alert("message clicke")
  }

  public currentPage = 'my-property-view';
}
